import { RouteRenderer } from '@/components/routing/RouteRenderer';
import { protectedRoutes, publicRoutes } from '@/config/routes.config';


function App() {
  return (
    <div className="App">
      <RouteRenderer
        protectedRoutes={protectedRoutes}
        publicRoutes={publicRoutes}
      />
    </div>
  );
}

export default App;